import React, { useContext, useEffect, useMemo, useState } from 'react';

import './stylesEventsList.css';
import CustomDatePicker from '../../CommonComponents/CustomDatePicker/CustomDatePicker';

import dayjs from 'dayjs';
import { ChevronDown, ChevronUp, Filter } from 'react-feather';
import { Button, Input, message, Pagination, Select, Table } from 'antd';
import createPrivateAdminPanelInstance from '../../../api/PrivateAdminPanelInstance';
import cashIcon from '../../../assets/images/cash.png';
import freeCashIcon from '../../../assets/images/free-cash.png';
import { API_ROUTES } from '../../../api/ApiRoutes';
import RebetLoader from '../../CommonComponents/RebetLoader/RebetLoader';
import ToggleSwitch from '../../CommonComponents/ToggleSwitch/ToggleSwitch';
import { useNavigate } from 'react-router-dom';
import CustomAutoCompleteControlled from '../../CommonComponents/CustomAutoComplete/CustomAutoCompleteControlled';
import { PushpinFilled, PushpinOutlined } from '@ant-design/icons';

import unpinIcon from '../../../assets/icons/ic_unpin.svg';

function EventsList({ activeTab, setActiveTab }) {
  const token = JSON.parse(localStorage.getItem('token'));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken,
    false
  );
  const todayRange = [dayjs(), dayjs()];
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  const [isApiRunning, setIsApiRunning] = useState(false);
  const [showExtraFilters, setShowExtraFilters] = useState(false);
  const [sportsBookDates, setSportsBookDates] = useState(todayRange);

  const [pinnedEvents, setPinnedEvents] = useState(() => {
    const stored = localStorage.getItem('pinnedEvents');
    return stored ? JSON.parse(stored) : [];
  });

  const [selectedSport, setSelectedSport] = useState(null);
  const [selectedLeague, setSelectedLeague] = useState(null);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [selectedBetId, setSelectedBetId] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedEventType, setSelectedEventType] = useState('match');
  const [selectedStatus, setSelectedStatus] = useState('Live');
  const [lastEvaluatedKey, setLastEvaluatedKey] = useState(null);

  const [sports, setSports] = useState([
    {
      value: 'Soccer',
      label: 'Soccer',
    },
    {
      value: 'Basketball',
      label: 'Basketball',
    },
    {
      value: 'Baseball',
      label: 'Baseball',
    },
  ]);
  const [leagues, setLeagues] = useState([
    {
      value: 'MLB',
      label: 'MLB',
    },
    {
      value: 'NBA',
      label: 'NBA',
    },
  ]);
  const [events, setEvents] = useState([]);
  const [eventTypes, setEventTypes] = useState([
    {
      value: 'match',
      label: 'Match',
    },
    {
      value: 'outright',
      label: 'Outright',
    },
  ]);

  const [providers, setProviders] = useState([
    {
      value: 'Sportradar',
      label: 'Sportradar',
    },
    {
      value: 'Oddin',
      label: 'Oddin',
    },
    {
      value: 'DST',
      label: 'DST',
    },
  ]);
  const statuses = [
    {
      value: null,
      label: 'All',
    },
    {
      value: 'Future',
      label: 'Future',
    },
    {
      value: 'Live',
      label: 'Live',
    },
    {
      value: 'Canceled',
      label: 'Canceled',
    },
    {
      value: 'Completed',
      label: 'Completed',
    },
  ];

  const [dataSource, setDataSource] = useState([]);
  const [betsToShowInTable, setBetsToShowInTable] = useState([]);
  const [pagination, setPagination] = useState({
    current_page: 1,
    page_size: 20,
    total_results: 0,
    total_pages: 0,
    has_next: false,
    has_prev: false,
  });
  const [betsCache, setBetsCache] = useState({});

  const [filterType, setFilterType] = useState('rebet_cash');

  const data = [
    {
      bet_id: '1234567890',
      username: 'Boston Celtics vs Philadelphia 76ers',
      event_name: 'Nov 12, 2024 12:30 PM',
      status: 'Future',
      sport: 'Basketball',
      category: 'England',
      league: 'NBA',
      scores: '-',
      location: 'Brazil',
      providers: ['Sportradar', 'DST'],
      money_type: 'rebet_cash',
      bet_amount: '5000',
      number_of_bets: '50',
      pre_match_tier: '1',
      live_tier: '1',
      live_time_delay: '1',
      suggested_live_time_delay: '1',
      pre_match_activity: '1',
      live_activity: '1',
    },
    {
      bet_id: '12345678901',
      username: 'Boston Celtics vs Philadelphia 76ers',
      event_name: 'Nov 12, 2024 12:30 PM',
      status: 'Hiden',
      sport: 'Basketball',
      category: 'India',
      league: 'NBA',
      scores: '43 : 32',
      location: 'India',
      providers: ['DST'],
      money_type: 'rebet_cash',
      bet_amount: '5000',
      number_of_bets: '50',
      pre_match_tier: '1',
      live_tier: '1',
      live_time_delay: '1',
      suggested_live_time_delay: '1',
      pre_match_activity: '1',
      live_activity: '1',
    },
    {
      bet_id: '123456789012',
      username: 'Boston Celtics vs Philadelphia 76ers',
      event_name: 'Nov 12, 2024 12:30 PM',
      status: 'Live',
      sport: 'Basketball',
      category: 'Egypt',
      league: 'NBA',
      scores: '-',
      location: 'Egypt',
      providers: ['Sportradar'],
      money_type: 'rebet_free_cash',
      bet_amount: '5000',
      number_of_bets: '50',
      pre_match_tier: '1',
      live_tier: '1',
      live_time_delay: '1',
      suggested_live_time_delay: '1',
      pre_match_activity: '1',
      live_activity: '1',
    },
    {
      bet_id: '123456789013',
      username: 'Boston Celtics vs Philadelphia 76ers',
      event_name: 'Nov 12, 2024 12:30 PM',
      status: 'Completed',
      sport: 'Basketball',
      category: 'Egypt',
      league: 'NBA',
      scores: '43 : 32',
      location: 'Egypt',
      providers: ['Sportradar'],
      money_type: 'rebet_free_cash',
      bet_amount: '5000',
      number_of_bets: '50',
      pre_match_tier: '1',
      live_tier: '1',
      live_time_delay: '1',
      suggested_live_time_delay: '1',
      pre_match_activity: '1',
      live_activity: '1',
    },
    {
      bet_id: '123456789013',
      username: 'Boston Celtics vs Philadelphia 76ers',
      event_name: 'Nov 12, 2024 12:30 PM',
      status: 'Canceled',
      sport: 'Basketball',
      category: 'Egypt',
      league: 'NBA',
      scores: '43 : 32',
      location: 'Egypt',
      providers: ['Sportradar', 'DST', 'Oddin'],
      money_type: 'rebet_cash',
      bet_amount: '5000',
      number_of_bets: '50',
      pre_match_tier: '1',
      live_tier: '1',
      live_time_delay: '1',
      suggested_live_time_delay: '1',
      pre_match_activity: '1',
      live_activity: '1',
    },
  ];

  const rebetCashData = data.filter((bet) => bet.money_type === 'rebet_cash');
  const rebetFreeCashData = data.filter(
    (bet) => bet.money_type === 'rebet_free_cash'
  );
  const [dataToShowInTable, setDataToShowInTable] = useState(rebetCashData);

  const togglePin = (event) => {
    const isPinned = pinnedEvents.some(
      (pinnedEvent) => pinnedEvent.id === event.id
    );

    const newPinnedEvents = isPinned
      ? pinnedEvents.filter((pinnedEvent) => pinnedEvent.id !== event.id)
      : [...pinnedEvents, event];

    setPinnedEvents(newPinnedEvents);
    localStorage.setItem('pinnedEvents', JSON.stringify(newPinnedEvents));
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 100,
      render: (text, record) => {
        const isPinned =
          pinnedEvents.filter((pinnedEvent) => pinnedEvent.id === record.id)
            .length > 0;
        return (
          <div className="events-list-id-container">
            {isPinned ? (
              <img
                src={unpinIcon}
                alt="Unpin"
                className="events-list-id-icon pinned"
                onClick={() => togglePin(record)}
              />
            ) : (
              <PushpinOutlined
                className="events-list-id-icon unpinned"
                onClick={() => togglePin(record)}
              />
            )}
            <p className="events-list-id-text">{record.id}</p>
          </div>
        );
      },
    },
    {
      title: 'Event Name',
      dataIndex: 'name',
      key: 'name',
      width: 150,
      render: (text, record) => (
        <div className="events-list-event-name-container">
          {record.away_logo && record.home_logo && (
            <div className="events-list-event-name-img-container">
              <img
                src={record.away_logo}
                alt="Event Logo"
                className="events-list-away-logo"
              />
              <img
                src={record.home_logo}
                alt="Event Logo"
                className="events-list-home-logo"
              />
            </div>
          )}
          <p
            className="events-list-event-name-text"
            onClick={() => handleEventClick(record.id)}
          >
            {text}
          </p>
        </div>
      ),
    },
    {
      title: 'Date & Time',
      dataIndex: 'scheduled',
      key: 'scheduled',
      width: 80,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 50,
      render: (text, record) => (
        <p className={`events-list-status ${record.status?.toLowerCase()}`}>
          {record.status}
        </p>
      ),
    },
    {
      title: 'Sport',
      dataIndex: 'sport',
      key: 'sport',
      width: 50,
    },
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
      width: 80,
    },
    {
      title: 'League',
      dataIndex: 'league',
      key: 'league',
      width: 100,
      render: (text, record) => (
        <div className="events-list-league-container">
          {record.league_logo && (
            <img
              src={record.league_logo}
              alt="League Logo"
              className="events-list-league-logo"
            />
          )}
          <p className="events-list-league-text">{text}</p>
        </div>
      ),
    },
    {
      title: 'Scores',
      dataIndex: 'scores',
      key: 'scores',
      width: 50,
    },
    {
      title: 'Location',
      dataIndex: 'location',
      key: 'location',
      width: 80,
    },
    {
      title: 'Provider',
      dataIndex: 'providers',
      key: 'providers',
      width: 50,
      render: (text, record) =>
        record.providers.length > 1 ? (
          <div className="events-list-providers">
            <Select
              value={null}
              onChange={() => {}}
              onSelect={() => {}}
              placeholder={record.providers.length + ' Providers'}
              options={record.providers.map((provider) => ({
                value: provider,
                label: provider,
              }))}
            />
          </div>
        ) : (
          <p style={{ margin: 0 }}>{record.providers[0]}</p>
        ),
    },
    {
      title: () => (
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <span>Bet Amount</span>
          <div className="bet-amount-buttons">
            <Button
              className={filterType === 'rebet_cash' ? 'active' : ''}
              onClick={() => handleFilterTypeChange('rebet_cash')}
            >
              <img src={cashIcon} alt="Cash" />
            </Button>
            <Button
              className={filterType === 'rebet_free_cash' ? 'active' : ''}
              onClick={() => handleFilterTypeChange('rebet_free_cash')}
            >
              <img src={freeCashIcon} alt="Free Cash" />
            </Button>
          </div>
        </div>
      ),
      dataIndex: 'bet_amount',
      key: 'bet_amount',
      width: 100,
      render: (text, record) => (
        <div className="bets-report-bet-amount-container">
          {filterType === 'rebet_cash' ? (
            <img src={cashIcon} alt="Cash" />
          ) : filterType === 'rebet_free_cash' ? (
            <img src={freeCashIcon} alt="Free Cash" />
          ) : (
            ''
          )}
          <span className="bets-report-bet-amount-text">
            {record.bet_amount === '-'
              ? '-'
              : Intl.NumberFormat('en-US', {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2,
                }).format(
                  filterType === 'rebet_cash'
                    ? record.bet_volume.rebet_cash
                    : record.bet_volume.rebet_free_cash
                )}
          </span>
        </div>
      ),
    },
    {
      title: 'Number of Bets',
      dataIndex: 'bet_count',
      key: 'bet_count',
      width: 80,
      render: (text, record) => (
        <span className="bets-report-bet-amount-text">
          {Intl.NumberFormat('en-US', {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
          }).format(record.bet_count)}
        </span>
      ),
    },
  ];

  const handleFilterTypeChange = (value) => {
    setFilterType(value);
    if (value === 'rebet_cash') {
      setDataToShowInTable(rebetCashData);
    } else {
      setDataToShowInTable(rebetFreeCashData);
    }
  };

  const reorderedData = useMemo(() => {
    const pinnedIds = pinnedEvents.map((e) => e.id);

    const pinned = pinnedEvents;
    const unpinned = betsToShowInTable.filter(
      (item) => !pinnedIds.includes(item.id)
    );

    return [...pinned, ...unpinned];
  }, [betsToShowInTable, pinnedEvents]);

  const getEventsList = async (
    page = 1,
    refresh = false,
    queryString = todayRange,
    isQueryString = true,
    updateFilters = true,
    lastEvaluatedKey = null
  ) => {
    let startDate = '';
    let endDate = '';

    if (isQueryString) {
      let formattedQueryString = queryString.split('&');
      startDate = dayjs(formattedQueryString[0]).format('YYYY-MM-DD');
      endDate = dayjs(formattedQueryString[1]).format('YYYY-MM-DD');
    } else {
      startDate = queryString[0]?.format('YYYY-MM-DD');
      endDate = queryString[1]?.format('YYYY-MM-DD');
    }

    const params = {
      start_date: startDate,
      end_date: endDate,
      page: page,
      provider: selectedProvider || null,
      sport_name: selectedSport || null,
      league_name: selectedLeague || null,
      event_type: selectedEventType || null,
      event_id:
        events.find((event) => event.label === selectedEvent)?.event_id || null,
      last_evaluated_key: lastEvaluatedKey,
      status: selectedStatus || null,
    };

    console.log('params', params);
    // return;
    const cacheKey = page;

    if (betsCache[cacheKey] && !refresh) {
      const cached = betsCache[cacheKey];
      setBetsToShowInTable(cached.bets);
      setPagination(cached.pagination);
      return;
    }

    try {
      setIsApiRunning(true);

      const response = await PrivateAdminPanelInstance?.post(
        API_ROUTES?.GET_SPORTSBOOK_EVENTS_LIST,
        params
      );
      const data = response.data.data;
      const bets = data.events;

      const sports = data.dropdowns?.popular_sports?.map((sport) => ({
        value: sport,
        label: sport,
      }));
      const leagues = data.dropdowns?.popular_leagues?.map((league) => ({
        value: league,
        label: league,
      }));
      const events = data.dropdowns?.popular_events?.map((event) => ({
        value: event.event_id,
        label: event.event_name,
        event_id: event.event_id,
      }));
      console.log('bets', data);

      const paginationData = {
        current_page: data?.pagination?.current_page,
        page_size: 20,
        total_results: data?.pagination?.has_next
          ? data?.pagination?.current_page * 20 + 1
          : data?.pagination?.current_page * 20,
        has_next: data?.pagination?.has_next,
        has_prev: data?.pagination?.has_prev,
      };

      setBetsToShowInTable(bets);
      setSports(sports);
      setLeagues(leagues);
      setEvents(events);
      setPagination(paginationData);
      setLastEvaluatedKey(data?.last_evaluated_key);

      setBetsCache((prev) => ({
        ...prev,
        [cacheKey]: {
          bets: bets,
          pagination: paginationData,
        },
      }));
    } catch (error) {
      message.error(error?.response?.data?.message || 'Something went wrong.');
    } finally {
      setIsApiRunning(false);
    }
  };

  const handlePaginationChange = (page) => {
    let queryStringParams = sportsBookDates ? sportsBookDates : todayRange;

    getEventsList(
      page,
      false,
      queryStringParams,
      false,
      false,
      lastEvaluatedKey
    );
  };

  const handleChangeBetId = (value) => {
    setSelectedBetId(value);
  };
  const handleLeagueChange = (value) => {
    setSelectedLeague(value);
  };

  const handleProviderChange = (value) => {
    setSelectedProvider(value);
  };

  const handleSportChange = (value) => {
    setSelectedSport(value);
  };

  const handleStatusChange = (value) => {
    setSelectedStatus(value);
  };

  const handleEventChange = (value) => {
    setSelectedEvent(value);
  };

  const handleEventTypeChange = (value) => {
    setSelectedEventType(value);
  };

  const handleEventClick = (id) => {
    navigate(`/event-details?event-id=${id}`);
  };

  const handleClearFilters = () => {
    setSelectedBetId(null);
    setSelectedSport(null);
    setSelectedLeague(null);
    setSelectedProvider(null);
    setSelectedStatus('Live');
    setSelectedEvent(null);
    setSelectedEventType('match');
  };

  const handleApplyFilters = () => {
    getEventsList(1, true, sportsBookDates, false, false, null);
  };

  const handleDateChange = (queryString) => {
    getEventsList(1, true, queryString, true, false, null);
  };

  useEffect(() => {
    getEventsList(1, true, sportsBookDates, false, true, null);
  }, []);

  return (
    <div className="events-list-container">
      {contextHolder}
      <div className="events-list">
        <>
          <div className="head-controls">
            <div className="header-text-container">
              <p className="header-text">Sportsbook</p>
            </div>
            <CustomDatePicker
              getData={handleDateChange}
              dates={sportsBookDates}
              setDates={setSportsBookDates}
              showPresets={true}
            />
          </div>

          <div className="events-list-content">
            <div className="events-list-content-header">
              <div className="sportsbook-tabs">
                <button
                  className={activeTab === 'Sportsbook KPI' ? 'active' : null}
                  onClick={() => setActiveTab('Sportsbook Kpi')}
                >
                  Sportsbook KPI
                </button>
                <button
                  className={activeTab === 'Events List' ? 'active' : null}
                  onClick={() => setActiveTab('Events List')}
                >
                  Events List
                </button>
                <button
                  className={activeTab === 'Latest Bets List' ? 'active' : null}
                  onClick={() => setActiveTab('Latest Bets List')}
                >
                  Latest Bets List
                </button>
              </div>
              <div className="events-list-autocomplete-container">
                <div
                  className="filter-buttons"
                  onClick={() => setShowExtraFilters(!showExtraFilters)}
                >
                  <Filter className="filter-icon" />
                  {showExtraFilters ? (
                    <ChevronUp className="filter-icon" />
                  ) : (
                    <ChevronDown className="filter-icon" />
                  )}
                </div>
              </div>
            </div>
            <div
              className="events-list-selectors"
              style={{ display: showExtraFilters ? 'flex' : 'none' }}
            >
              <div className="events-list-selector">
                <span>Provider</span>
                <Select
                  placeholder="Not Selected"
                  value={selectedProvider}
                  onChange={(value) => handleProviderChange(value)}
                  options={providers}
                />
              </div>
              <div className="events-list-selector">
                <span>Sport</span>
                <CustomAutoCompleteControlled
                  placeholder="Not Selected"
                  value={selectedSport}
                  allOptions={sports}
                  handleChange={(value) => handleSportChange(value)}
                  clearOptions={() => handleSportChange(null)}
                  selector="value"
                />
                {/* <Select
                  placeholder="Not Selected"
                  value={selectedSport}
                  onChange={(value) => handleSportChange(value)}
                  options={sports}
                /> */}
              </div>
              <div className="events-list-selector">
                <span>League</span>
                <CustomAutoCompleteControlled
                  placeholder="Not Selected"
                  value={selectedLeague}
                  allOptions={leagues}
                  handleChange={(value) => handleLeagueChange(value)}
                  clearOptions={() => handleLeagueChange(null)}
                  selector="value"
                />
              </div>
              <div className="events-list-selector">
                <span>Event</span>
                <CustomAutoCompleteControlled
                  placeholder="Not Selected"
                  value={selectedEvent}
                  allOptions={events}
                  handleChange={(value) => handleEventChange(value)}
                  clearOptions={() => handleEventChange(null)}
                  selector="label"
                />
              </div>
              <div className="events-list-selector">
                <span>Event Type</span>
                <Select
                  placeholder="Not Selected"
                  value={selectedEventType}
                  onChange={(value) => handleEventTypeChange(value)}
                  options={eventTypes}
                />
              </div>
              <div className="events-list-selector">
                <span>Status</span>
                <Select
                  placeholder="Not Selected"
                  value={selectedStatus}
                  onChange={(value) => handleStatusChange(value)}
                  options={statuses}
                />
              </div>
            </div>
            {showExtraFilters && (
              <div className="events-list-selector-action-buttons">
                <button className="clear" onClick={() => handleClearFilters()}>
                  Clear Filters
                </button>
                <button className="apply" onClick={() => handleApplyFilters()}>
                  Apply
                </button>
              </div>
            )}
            {isApiRunning ? (
              <RebetLoader height={'100px'} width={'100px'} />
            ) : (
              <div className="events-list-kpis-table">
                <Table
                  columns={columns}
                  dataSource={reorderedData}
                  pagination={false}
                  scroll={{ x: 2500 }}
                  rowKey={(record) => record.bet_id}
                  sticky
                  rowClassName={(record) =>
                    pinnedEvents.filter(
                      (pinnedEvent) => pinnedEvent.id === record.id
                    ).length > 0
                      ? 'pinned-row'
                      : ''
                  }
                  // onRow={(record) => ({
                  //   style: { cursor: "pointer" },
                  //   onClick: () => {
                  //     navigate(`/event-details?bet-id=${record.bet_id}`);
                  //   },
                  // })}
                />
                <div className="sports-bets-pagination-container">
                  <Pagination
                    current={pagination.current_page}
                    total={pagination.total_results}
                    pageSize={20}
                    showSizeChanger={false}
                    onChange={(page) => {
                      if (
                        page === pagination.current_page - 1 ||
                        page === pagination.current_page + 1
                      ) {
                        handlePaginationChange(page);
                      }
                    }}
                    itemRender={(page, type, originalElement) => {
                      if (type === 'page') {
                        return (
                          <a
                            rel="nofollow"
                            disabled={page > pagination.current_page + 1}
                            className={`${
                              page > pagination.current_page + 1
                                ? 'disabled'
                                : ''
                            }`}
                          >
                            {page}
                          </a>
                        );
                      }
                      return originalElement;
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </>
      </div>
    </div>
  );
}

export default EventsList;
